import { instance, config } from './axios.js'
import siteConfig from "../config.js";
const NODE_ENV = process.env.NODE_ENV
const apiConfig = ()=>{
 return config(siteConfig[NODE_ENV]['apiPrefix'] + '/vip')
}
export default {

  getEventList({ type = 'all', limit = 0, skip = 0 } = {}) {
    return instance.get(`/event/getEventList/${type}?limit=${limit}&skip=${skip}`, apiConfig());
  },
}
